module.exports = __webpack_public_path__ + "static/media/assembly11.3dbb7b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly11.png
// module id = 2429
// module chunks = 0